import * as React from "react";
import CommandBar from "@ea/shared_components/CommandBar/CommandBar";
import CommandBarButton from "@ea/shared_components/CommandBar/CommandBarButton";
import { getTranslationKey } from "@app/translations/translations.helpers";
import { User } from "@ea/shared_types/types";
import { DataTestIds } from "@app/utils/dataTestIds";

interface ScriptsCommandBarProps {
  onNewClick: () => void;
  onRemoveClick: (ids: number[]) => void;
  onEditClick: () => void;
  onPasswordClick: () => void;
  onReload: () => void;
  selected: number[];
  user: User | undefined;
}
class ScriptsCommandBar extends React.Component<ScriptsCommandBarProps> {
  private container: HTMLElement;

  public render() {
    if (!this.props.user) {
      return null;
    }
    return (
      <CommandBar data-testid={DataTestIds.COMMANDBAR_USERS}>
        <CommandBarButton
          name="new"
          onClick={this.props.onNewClick}
          text={getTranslationKey("commandBar", "add")}
          icon="PlusOutlined"
          data-testid={DataTestIds.COMMANDBAR_BUTTON_NEW}
        />
        <CommandBarButton
          name="remove"
          onClick={() => this.props.onRemoveClick(this.props.selected)}
          text={getTranslationKey("commandBar", "remove")}
          icon="DeleteOutlined"
          data-testid={DataTestIds.COMMANDBAR_BUTTON_REMOVE}
          disabled={
            this.props.selected.length !== 0
              ? this.props.selected.indexOf(this.props.user.id) >= 0
              : true
          }
        />
        <CommandBarButton
          name="refresh"
          onClick={this.props.onReload}
          text={getTranslationKey("commandBar", "refresh")}
          icon="ReloadOutlined"
          data-testid={DataTestIds.COMMANDBAR_BUTTON_REFRESH}
        />
        <CommandBarButton
          name="edit"
          onClick={this.props.onEditClick}
          text={getTranslationKey("commandBar", "edit")}
          icon="EditOutlined"
          disabled={this.props.selected.length !== 1}
          data-testid={DataTestIds.COMMANDBAR_BUTTON_EDIT}
        />
        <CommandBarButton
          name="password"
          onClick={this.props.onPasswordClick}
          text={getTranslationKey("commandBar", "password")}
          icon="LockOutlined"
          disabled={this.props.selected.length !== 1}
          data-testid={DataTestIds.COMMANDBAR_BUTTON_PASSWORD}
        />
      </CommandBar>
    );
  }
}
export default ScriptsCommandBar;
